var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:['container', _vm.theme]},[_c(_vm.loaders[_vm.type],{tag:"component",attrs:{"text":_vm.text,"theme":_vm.theme,"max":_vm.max,"timeConstant":_vm.timeConstant,"color":_vm.color}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }